import style from 'styled-components';

export const StyledPromocionesSection = style.div`
	background: ${props => (props.background ? `url(${props.background}) no-repeat` : `white`)};
  min-height: 600px;
  padding-left: -15px;
  padding-right: -15px;
  
  h2 {
    margin-bottom: 16px;
  }

  h1 {
    margin-bottom: 8px;
  }

  p {
    font-size: 12px;
  }

  .no-promotion-text{
    font-size: 20px;
    text-align: center;
  }

  .card-promotion {
    padding:50px;

    &:hover {
      padding:45px;
      border-radius:12px;
      transition: all 0.2s ease 0s;
    } 

    .card-promotion__img {
      span {
        display: flex!important;
        height: 100%!important;
        position: relative;
          img {
            max-width: 100%;
            height: auto;
            border-radius:12px;

            &:hover {
              box-shadow: rgb(45 62 80 / 35%) 0px 1px 6px 0px;
              border-radius:12px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .card-promotion {
      padding: 20px;
    }
  }
`;
